<template>
    <div class="stack mb-3">
        <div class="m-auto shadow text-left control-width border add-rounded p-4">
            <p class="text-danger text-center font-weight-bolder" v-if="error">
                {{ error }}
            </p>
            <h5 class="mb-3 kova-text">
                Brief introduction about yourself and your work experience
            </h5>
            <!-- <a-textarea size="large" placeholder="I worked as senior developer at with name workplace..." class="m-auto" :autosize="{ minRows: 4, maxRows: 8 }"/> -->
            <vue-editor
                id="editor"
                class="briefing d-none"
                useCustomImageHandler
                @image-added="handleImageAdded"
                placeholder="Introduce yourself..."
            ></vue-editor>

            <a-textarea placeholder="Introduce yourself..." allow-clear rows="8" v-model="about_me" />

            <h5 class="mt-4 kova-text">Select your hourly rates</h5>
            <a-radio-group v-model="work_rate">
                <a-radio class="mb-2" :style="radioStyle" v-for="level in levels" :key="level.id" :value="level.id">
                    <span class="text-size2 mt-n1"> {{ level.work_rate }}/hr ({{ level.level }}) </span>
                </a-radio>
            </a-radio-group>

            <h5 class="mt-4 kova-text">Country of residence</h5>
            <a-select
                class="w-100"
                size="large"
                show-search
                @change="city = null"
                v-model="country"
                placeholder="Please select your Country"
            >
                <a-select-option :value="item.name" v-for="(item, index) in countries" :key="index">
                    {{ item.name }}
                </a-select-option>
            </a-select>
            <h5 class="mt-4 kova-text" v-if="country">Which city are you located in {{ country }}</h5>
            <a-select
                v-if="country"
                class="w-100"
                show-search
                v-model="city"
                size="large"
                placeholder="Please select your City"
            >
                <a-select-option :value="item.name" v-for="(item, index) in states" :key="index">
                    {{ item.name }}
                </a-select-option>
            </a-select>
            <div class="container-fluid px-0 px-md-4 mb-5 mt-5" v-if="!overview">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack">
                            Back
                        </button>
                    </div>
                    <div class="col text-right">
                        <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" @click.prevent="next">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { VueEditor } from 'vue2-editor';
import countries from '../../data/countries.json';

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const { work_experience } = vm.$store.state.talent.talentData;

            if (work_experience == null) vm.$router.back();
        });
    },
    name: 'stack',
    components: {
        VueEditor,
    },
    props: {
        overview: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        states() {
            const country = this.countries.find(key => key.name === this.country);
            return country ? country.states : [];
        },
    },
    mounted() {
        const { country, about_me, work_rate, city } = this.$store.state.talent.talentData;

        this.country = country;
        this.about_me = about_me;
        this.work_rate = work_rate || 0;
        this.city = city;
    },
    data() {
        return {
            countries,
            VueEditor,
            about_me: '',
            country: '',
            city: '',
            work_rate: 0,
            error: '',
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        next() {
            const { country, work_rate, about_me, city } = this;

            this.error = !about_me
                ? 'Write a brief introduction about yourself'
                : !work_rate
                ? 'Pick your hourly rate'
                : !country
                ? 'Please select a country'
                : !city
                ? 'Please select a city'
                : '';
            if (this.error.length) return document.querySelector('.devsignup').scrollIntoView();

            this.$store.commit('talent/addToTalent', {
                ...this.$store.state.talent.talentData,
                country,
                about_me,
                work_rate: Number(work_rate),
                city,
            });

            if (this.overview) return this.$emit('valid');
            this.$router.push('/devsignup/overview');
        },
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append('file', file);

            this.$http({
                url: 'https://fakeapi.yoursite.com/images',
                method: 'POST',
                data: formData,
            }).then(result => {
                let url = result.data.url; // Get url from response
                Editor.insertEmbed(cursorLocation, 'file', url);
                resetUploader();
            });
            // .catch(err => {
            // console.log(err);
            // });
        },
    },
    watch: {
        country() {
            const { country } = this;
            this.$store.commit('talent/updateTalent', {
                country,
            });
        },
        about_me() {
            const { about_me } = this;
            this.$store.commit('talent/updateTalent', {
                about_me,
            });
        },
        city() {
            const { city } = this;
            this.$store.commit('talent/updateTalent', {
                city,
            });
        },
        work_rate() {
            this.$store.commit('talent/updateTalent', {
                work_rate: Number(this.work_rate),
            });
        },
    },
};
</script>
<style scoped>
.control-width {
    width: 600px;
}
h3.kova-text {
    font-size: 20px;
}

.text-size2,
h5.kova-text {
    font-size: 16px;
}

/* .briefing >>> .ql-formats:, */
/* .briefing >>> .ql-formats:last-of-type, */
.briefing >>> .ql-formats {
    display: none;
}

.briefing >>> .ql-formats:nth-child(2),
.briefing >>> .ql-formats:nth-child(4),
.briefing >>> .ql-formats:nth-child(5) {
    display: inline-block;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
    .control-width {
        width: 500px;
    }
}
@media (max-width: 550px) {
    .control-width {
        width: 98%;
    }
}
</style>
